
import axiosServices from './request';

const ChannelCenter = axiosServices('channelcenter');

export default {
  //1.获取JS_SDK的参数
  getSDKParam: ChannelCenter('get', 'accountSetting/getAppParam'),
  // 不需要cookie来获取
  getSDKParamByOffId: ChannelCenter('get', 'accountSetting/getAppParamByOffId'),

  /** 增加自有码扫码埋点 */
  addSendScanInfo: ChannelCenter('get', 'qrcodeScene/addSendScanInfo'),

  /** 根据二维码id获取书名和跳转二维码 */
  getBySceneId: ChannelCenter('get', 'channelSceneUrl/getBySceneId'),

  /** 根据二维码链接获取书籍信息 */
  getQrcodeInfoByUrl: ChannelCenter('get', 'appletQrcodeScene/getScanCodeInfoByWxScanResult'),

  //根据公众号id获取二维码
  getAccountSettingInfo: ChannelCenter('get', 'accountSetting/getAccountSettingInfo'),

  //获取公众号信息
  getOpreateManageInfo: ChannelCenter('get', 'accountSetting/getOpreateManageInfo'),

  getDomainByWechat: ChannelCenter('get', 'accountSetting/getDomainByWechat'),

  /**通过场景id获取二维码禁用信息 */
  get4Wechat: ChannelCenter('get', 'qrcodeScene/get4WechatBase'),

  // 打包活动资源
  listBookServe4Wechat: ChannelCenter('get', 'bookPackServe/listBookServe4Wechat'),
  // H5-打包活动弹窗信息
  getBookPackPopup4Wechat: ChannelCenter('get', 'bookPackServe/getBookPackPopup4Wechat'),
  // 添加红包记录
  addRedPacketRecord: ChannelCenter('post', 'bookPackServe/addRedPacketRecord'),

  /** 图片校验(新增图片校验记录) */
  checkImgQrcode: ChannelCenter('post', 'nftSceneCheckRecord/insert'),
  /** 新增申诉 */
  insertAppeal: ChannelCenter('post', 'nftSceneAppeal/insert'),
  /** 获取邮票申诉状态 */
  getAppealState: ChannelCenter('get', 'nftSceneAppeal/getAppealState'),
  /** 撤回申诉 */
  softDeleteById: ChannelCenter('get', 'nftSceneAppeal/softDeleteById'),

  /** 判断二维码按是否属于孔祥东 */
  isKXDBySceneId: ChannelCenter('get', 'qrcodeScene/isKXDBySceneId'),

  /**根据bookid获取sceneid */
  getOneSceneId: ChannelCenter('get', 'qrcodeScene/getOneSceneId'),

  // 二维码是否允许使用新界面
  allowNewStyle: ChannelCenter('get', 'qrcodeScene/allowNewStyle'),

  // 魔方书下的二维码
  listRaysSceneCode: ChannelCenter('get', 'qrcodeScene/listRaysSceneCode'),

  // 【rays码配置】落地页查询接口-根据rays码id查询用户所在省份是否可见【rays码配置】落地页查询接口-根据rays码id查询用户所在省份是否可见
  getIfCanSeeBySceneId: ChannelCenter('get', 'qrcodeScene/getIfCanSeeBySceneId'),

  // 判断是否是抖音引流码数据
  isDrainageCode: ChannelCenter('get', 'standardBook/isDrainageCode'),

  // 根据项目code获取图书配置资源
  getBookResourceByCode: ChannelCenter('get', 'standardBook/getBookResourceByCode'),

  // 根据书刊查询二维码列表
  pageBookQrCodeList: ChannelCenter('get', 'standardBook/pageBookQrCodeList'),

  // 根据书刊名称分页查询项目列表
  pageBooktList: ChannelCenter('get', 'standardBook/pageBooktList'),

  // 根据引流码id获取对应的跳转地址
  getSceneUrl: ChannelCenter('get', 'standardBook/getSceneUrl'),

  // 获取校验二维码信息
  getQrcodeBaseInfoByScan4Adviser: ChannelCenter('get', 'appletQrcodeScene/getQrcodeBaseInfoByScan4Adviser'),
  // 二维码资源列表落地页
  getQrMessageBySceneId4Wechat: ChannelCenter('get', 'qrcodeScene/getQrMessageBySceneId4Wechat'),
  // 分类列表
  listCatalog4Wechat: ChannelCenter('get', 'qrcodeSceneCatalog/listCatalog4Wechat')
};
